module.exports = __webpack_public_path__ + "img/clue06.477a3f24.png";